<!--
 * @Author: 黄昱森
 * @LastEditors: 黄昱森
 * @Description: 
-->
<template>
  <div class="lc-card2">
    <div v-if="$slots.header" class="lc-card2__header">
      <slot name="header" />
    </div>
    <div class="lc-card2__body">
      <slot />
    </div>
    <div v-if="$slots.footer" class="lc-card2__footer">
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LcCard2',
  data() {
    return {};
  },
  created() {
    // preset
  },
  mounted() {
    // preset
  },
  methods: {}
};
</script>